import { Tabs, TabsProps } from "antd";
import SchedulesTab from "./components/schedules-tab";
import { useLocation, useSearchParams } from "react-router-dom";
import useNavigateWithParams from "hooks/use-navigate-with-params";
import WorkingHoursTab from "pages/working-hours/page";
import ManagersTab from "pages/managers/page";
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "services/axios";
import { useMemo } from "react";
import { find, get } from "lodash";
import MdTab from "../md/page";
import ExplanationLetter from "../explanation-letter/page";
import EmployeeAttendance from "../employee-attendance/page";
import EmployeeBlackListTab from "pages/md/Employee";
import MdTabs from "pages/md/mdTabs";
import PartnersTab from "pages/partners/page";

const HomePage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigateWithParams();
  const [searchParams] = useSearchParams();

  const { data: userPermissionsData } = useQuery({
    queryKey: ["schedule-user-permissions"],
    queryFn: async () => {
      axiosInstance.defaults.headers.common.Authorization =
        searchParams.get("token");
      return await axiosInstance.get("/turniket/v1/bitrix-user/me");
    },
  });

  const permissions: Record<string, boolean> = useMemo(
    () => get(userPermissionsData, "data.data", {}),
    [userPermissionsData]
  );

  const items = useMemo(() => {
    const tabs: TabsProps["items"] = [];

    if (get(permissions, "canReadSchedule"))
      tabs.push({
        key: "schedules",
        label: "Schedules",
        children: <SchedulesTab permissions={permissions} />,
      });
    if (get(permissions, "canReadManager"))
      tabs.push({
        key: "managers",
        label: "Managers",
        children: <ManagersTab permissions={permissions} />,
      });
    if (get(permissions, "canReadWorkDayReport"))
      tabs.push({
        key: "working-hours",
        label: "Working Hours",
        children: <WorkingHoursTab permissions={permissions} />,
      });
    if (get(permissions, "canReadMD")) {
      tabs.push({
        key: "md",
        label: "MD",
        children: <MdTabs permissions={permissions} />,
      });
    }
    if (get(permissions, "canReadExplanationLetter"))
      tabs.push({
        key: "explanation-letter",
        label: "Tushuntirish xati",
        children: <ExplanationLetter permissions={permissions} />,
      });
    tabs.push({
      key: "employee-attendance",
      label: "Xodimlar Davomat Paneli",
      children: <EmployeeAttendance />,
    });
    if (get(permissions, "canReadManager"))
      tabs.push({
        key: "partners",
        label: "Hamkorlar",
        children: <PartnersTab />,
      });

    return tabs;
  }, [permissions]);

  const activeKey = () => {
    let key = pathname.split("/").pop() || "schedules";
    if (!find(items, (item) => item.key === key)) return items[0]?.key;
    return key;
  };

  const handleTabChange = (key: string) => {
    const path = key === "schedules" ? "/" : `/${key}`;
    navigate(path);
  };

  return (
    <div className="p-2">
      <Tabs activeKey={activeKey()} onChange={handleTabChange} items={items} />
    </div>
  );
};

export default HomePage;
